import _ from 'lodash'
import { getInvoicesQuery, createInvoiceMutation, deleteInvoiceMutation, updateInvoiceMutation, getInvoiceByIdQuery } from '~graphql/invoices.graphql'

export default {
  getInvoices({ state, dispatch, commit }, { filter, offset, first, orderBy }) {
    commit('SET_ITEM', {
      state,
      item: [],
      modelName: 'invoices'
    })
    const defaultFilter = {
      id: {
        isNull: false
      } // used to allow empty filter
    }
    const mergedFilter = _.merge(filter, defaultFilter)

    return dispatch('getItems', {
      state,
      loader: 'invoices:get',
      modelName: 'invoices',
      query: getInvoicesQuery,
      resultPath: 'invoices.nodes',
      totalPath: 'invoices.totalCount',
      totalModelName: 'invoicesCount',
      variables: {
        filter: mergedFilter,
        offset,
        first,
        orderBy
      }
    })
  },
  getInvoiceById({ state, dispatch }, id) {
    return dispatch('getItemById', {
      id,
      state,
      loader: 'invoices:get',
      addTo: ['invoices'],
      query: getInvoiceByIdQuery,
      resultPath: 'invoice'
    })
  },
  createInvoice({ state, dispatch }, invoice) {
    return dispatch('createItem', {
      item: { invoice },
      state,
      loader: 'invoice:create',
      addTo: ['invoices'],
      mutation: createInvoiceMutation,
      resultPath: 'createInvoice.invoice'
    })
  },
  updateInvoice({ state, dispatch }, payload) {
    return dispatch('updateItem', {
      item: payload,
      state,
      modelName: 'selectedInvoice',
      addTo: ['invoices'],
      loader: 'invoice:update',
      mutation: updateInvoiceMutation,
      resultPath: 'updateInvoice.invoice'
    })
  },
  deleteInvoice({ state, dispatch }, id) {
    return dispatch('deleteItem', {
      id,
      state,
      modelName: 'selectedInvoice',
      removeFrom: ['invoices'],
      loader: 'invoice:delete',
      mutation: deleteInvoiceMutation
    })
  },
  setSelectedInvoice({ state, commit }, selectedInvoice) {
    commit('SET_ITEM', {
      state,
      item: selectedInvoice,
      modelName: 'selectedInvoice'
    })
  }
}
